module.exports = __webpack_public_path__ + "img/collar topline length.bbc5019e.png";